export default "__VITE_ASSET__INzdfl3S__"